import React from "react";
import Select from "react-select";
import { Grid } from "@mui/material";

export default function SortBy({ sortBy, setSortBy, setPage, agents }) {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "200px",
      fontsize: "14px",
      lineHeight: "20px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontWeight: 600,
      color: data.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: data.color,
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setSortBy({
      ID: e.value,
      name: e.label,
    });
    setPage(1);
  };

  return (
    <Grid item xs={12}>
      <Select
        aria-labelledby="aria-label"
        styles={style}
        options={agents}
        onChange={handleTypeSelect}
        isSearchable={false}
        isOptionDisabled={(option) => option.isDisabled}
        components={{
          IndicatorSeparator: () => null,
        }}
        value={agents.find(function (option) {
          return option.value === sortBy;
        })}
      />
    </Grid>
  );
}
